import {
  Spacing
} from 'UI'

export default {
  cardRow: {
    display: 'flex',
    alignItems: 'center',
    '& > div:nth-child(1)': {
      padding: () => Spacing(0, 5, 0, 0)
    },
    '& > div:nth-child(2)': {
      padding: () => Spacing(0, 4)
    },
    '& > div:nth-child(3)': {
      padding: () => Spacing(0, 0, 0, 5)
    }
  },
  satisfiedOrRefundedContainer: {
    width: '100%',
    margin: () => Spacing(6, 0, 11, 0)
  },
  titleClass: {
    width: '100%'
  },
  subTitleClass: {
    width: '100%'
  },
  teamSubscriptionVerticalCardContainer: {
    height: 586
  }
}
